import LogoProvider from './hooks/useLogo';

import { LogoProps } from './@types/LogoProps';
import LogoLink from './handles/LogoLink';
import LogoContainer from './handles/LogoContainer';
import LogoImage from './handles/LogoImage';

import './Logo.scss';

const Logo = (props: LogoProps) => (
	<LogoProvider {...props}>
		<LogoLink>
			<LogoContainer>
				<LogoImage></LogoImage>
			</LogoContainer>
		</LogoLink>
	</LogoProvider>
);

export default Logo;
